import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type BlogDetailHeader } from "./types";

export default {
  init: (
    apiInfo: ModuleApiInfo,
    { postId, ...args }: BlogDetailHeader.Api.InitRequest
  ): Promise<HttpApiResponse<BlogDetailHeader.Api.InitResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/blog/posts/${postId}`, args)
};
